import { useStaticQuery, graphql } from 'gatsby'

export function useDataCompetencies() {
    const dataCompetencies = useStaticQuery(graphql`
        {
            title: datoCmsRenshinPageAbout(title: { eq: "Competencies: Title" }, locale: { eq: "hy" }) {
                value
            }

            text: datoCmsRenshinPageAbout(title: { eq: "Competencies: Text" }, locale: { eq: "hy" }) {
                value
            }

            heroImage: datoCmsRenshinPageAbout(title: { eq: "Competencies: Image" }, locale: { eq: "hy" }) {
                image {
                    url
                }
            }

            items: allDatoCmsRenshinCompetencie(sort: { fields: [sorting], order: ASC }, filter: { locale: { eq: "hy" } }) {
                nodes {
                    text
                    image {
                        url
                    }
                }
            }
        }
    `)

    return dataCompetencies
}
